import { render, staticRenderFns } from "./ValidateAccountView.vue?vue&type=template&id=6d84b4f7&"
import script from "./ValidateAccountView.vue?vue&type=script&lang=ts&"
export * from "./ValidateAccountView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports